// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"c8e6f3bc","83":"483f6299","308":"6a4fb723","353":"1a43c3db","404":"d7f44779","453":"99d29666","629":"57d839b1","775":"128ad01b"}[chunkId] + ".chunk.js";
};